export const hrRoutes = {
  root: '/',
  employeeWorkbench: '/employee-workbench',
  approval: '/approval',
  employee: '/employee',
  positionSettings: '/position-settings',
  jobLevelSettings: '/job-level-settings',
  workLocationSettings: '/work-location-settings',
  workflowIntegrationSettings: '/workflow-integration-settings',
  employeeNew: '/employee/new',
  employeeRecycleBin: '/employee/recycle-bin',
  employeeDetail: (uuid: string) => `/employee/${uuid}`,
  onboarding: '/onboarding',
  onboardingNew: '/onboarding/new',
  onboardingEdit: (uuid: string) => `/onboarding/${uuid}/edit`,
  onboardingEditProfile: (uuid: string) =>
    `/onboarding/${uuid}/edit?mode=profile`,
  onboardingEditMaterials: (uuid: string) =>
    `/onboarding/${uuid}/edit?mode=materials`,
  onboardingView: (uuid: string) => `/onboarding/${uuid}/view`,
  onboardingCandidateReview: (uuid: string) =>
    `/onboarding?candidateOrderUuid=${encodeURIComponent(uuid)}`,
  regularization: '/regularization',
  regularizationNew: (employeeUuid: string) =>
    `/regularization/new?employeeUuid=${encodeURIComponent(employeeUuid)}`,
  regularizationEdit: (uuid: string) => `/regularization/${uuid}/edit`,
  regularizationView: (uuid: string) => `/regularization/${uuid}/view`,
  employeeChange: '/employee-change',
  employeeChangeNew: (employeeUuid?: string) =>
    employeeUuid
      ? `/employee-change/new?employeeUuid=${encodeURIComponent(employeeUuid)}`
      : '/employee-change/new',
  employeeChangeEdit: (uuid: string) => `/employee-change/${uuid}/edit`,
  employeeChangeView: (uuid: string) => `/employee-change/${uuid}/view`,
  selfProfile: '/me/profile',
  selfCertificateRequests: (uuid?: string) =>
    uuid
      ? `/me/certificate-requests?uuid=${encodeURIComponent(uuid)}`
      : '/me/certificate-requests',
  employeeLifecycleAudits: '/employee-lifecycle-audits',
  laborRelations: '/labor-relations',
  handoverTemplates: '/handover-templates',
  certificateRequests: '/certificate-requests',
  employeeRelationsAnalysis: '/employee-relations-analysis',
  resignation: '/resignation',
  resignationNew: (employeeUuid?: string) =>
    employeeUuid
      ? `/resignation/new?employeeUuid=${encodeURIComponent(employeeUuid)}`
      : '/resignation/new',
  resignationEdit: (uuid: string) => `/resignation/${uuid}/edit`,
  resignationView: (uuid: string) => `/resignation/${uuid}/view`,
  attendanceWorkbench: '/attendance-center/overview',
  attendanceApproval: '/attendance-center/approval',
  attendanceRecords: '/attendance-center/records',
  attendanceDaily: '/attendance-center/daily-results',
  attendanceMonthly: '/attendance-center/monthly-summary',
  attendanceLeave: '/attendance-center/leave-requests',
  attendanceOvertime: '/attendance-center/overtime-requests',
  attendancePunch: '/attendance-center/punch-requests',
  attendanceShifts: '/attendance-center/shifts',
  attendanceRules: '/attendance-center/rules',
  attendanceGroups: '/attendance-center/groups',
  attendanceSchedules: '/attendance-center/schedules',
  attendanceHolidayPlans: '/attendance-center/holiday-plans',
  attendanceLeaveBalances: '/attendance-center/leave-balances',
  attendanceLeaveGrantPolicies: '/attendance-center/leave-grant-policies',
  attendanceSetting: '/attendance-center/settings/automation',
  attendanceDevices: '/attendance-center/settings/devices',
  attendanceWorkflowSettings: '/attendance-center/settings/workflow',
  payrollWorkbench: '/payroll-center/overview',
  payrollApproval: '/payroll-center/approval',
  payrollPlans: '/payroll-center/plans',
  payrollItems: '/payroll-center/items',
  payrollInputs: '/payroll-center/inputs',
  payrollSourceBatches: '/payroll-center/source-batches',
  payrollTaxSimulation: '/payroll-center/tax-simulation',
  payrollCostAllocation: '/payroll-center/cost-allocation',
  payrollProfiles: '/payroll-center/profiles',
  payrollRuns: '/payroll-center/runs',
  payrollSlips: '/payroll-center/slips',
  payrollMySlips: '/payroll-center/my',
  payrollTeamSummary: '/payroll-center/team-summary',
  payrollAudits: '/payroll-center/audits',
} as const;
